import { Modal } from "react-bootstrap";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { UC_REPORT_TYPES } from "./utilizationReportUtils";
import { getCertificateKey } from "./utilizationUcReportAdapter";
import UtilizationUcReportDraft from "./UtilizationUcReportDraft";

const UtilizationUcReportModal = ({
  open,
  onClose,
  selectedFyLabel,
  selectedMonthLabel,
  ucType,
  onUcTypeChange,
  onGenerate,
  onSaveAndGenerate,
  loading = false,
  saving = false,
  ucReportData = null,
  checksExercisedByScheme = {},
  onCheckChange,
  onCheckAdd,
  onCheckRemove,
}) => {
  const certificates = ucReportData?.certificates || [];
  const showDraft = certificates.length > 0;
  const isBusy = loading || saving;
  const draftTitle =
    showDraft && certificates.length > 1
      ? `UC Report Draft (${certificates.length} Certificates)`
      : "UC Report Draft";

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      size={showDraft ? "xl" : undefined}
      dialogClassName={
        showDraft ? "utilization-uc-modal__dialog--draft" : undefined
      }
      className="utilization-uc-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {showDraft ? draftTitle : "Generate UC Report"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showDraft ? (
          <>
            <p className="utilization-uc-modal__subtitle">
              Utilization Certificate (UC) report for the selected period
            </p>

            <div className="utilization-uc-modal__info">
              <div className="utilization-uc-modal__info-row">
                <span className="utilization-uc-modal__info-label">
                  Financial Year
                </span>
                <span className="utilization-uc-modal__info-value">
                  {selectedFyLabel}
                </span>
              </div>
              <div className="utilization-uc-modal__info-row">
                <span className="utilization-uc-modal__info-label">Month</span>
                <span className="utilization-uc-modal__info-value">
                  {selectedMonthLabel}
                </span>
              </div>
            </div>

            <div className="utilization-uc-modal__type-section">
              <span className="utilization-uc-modal__type-label">
                Select UC Type
              </span>
              <FormControl
                component="fieldset"
                className="utilization-uc-modal__radio-group"
              >
                <RadioGroup
                  value={ucType}
                  onChange={(e) => onUcTypeChange(e.target.value)}
                >
                  {UC_REPORT_TYPES.map((type) => (
                    <FormControlLabel
                      key={type.value}
                      value={type.value}
                      control={<Radio size="small" />}
                      label={type.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </>
        ) : (
          <div className="utilization-uc-modal__draft-wrap">
            {certificates.map((certificate, index) => {
              const certificateKey = getCertificateKey(certificate, index);

              return (
                <UtilizationUcReportDraft
                  key={certificateKey}
                  data={certificate}
                  checksExercised={checksExercisedByScheme[certificateKey] || [""]}
                  onCheckChange={(checkIndex, value) =>
                    onCheckChange(certificateKey, checkIndex, value)
                  }
                  onCheckAdd={() => onCheckAdd(certificateKey)}
                  onCheckRemove={(checkIndex) =>
                    onCheckRemove(certificateKey, checkIndex)
                  }
                  certificateIndex={index + 1}
                  certificateCount={certificates.length}
                />
              );
            })}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {showDraft ? (
          <>
            <button
              type="button"
              className="utilization-uc-modal__btn utilization-uc-modal__btn--cancel"
              onClick={onClose}
              disabled={isBusy}
            >
              Close
            </button>
            <button
              type="button"
              className="utilization-uc-modal__btn utilization-uc-modal__btn--save"
              onClick={onSaveAndGenerate}
              disabled={isBusy}
            >
              {saving ? "Sending OTP..." : "Save and Generate Certificate"}
            </button>
          </>
        ) : (
          <>
            <button
              type="button"
              className="utilization-uc-modal__btn utilization-uc-modal__btn--cancel"
              onClick={onClose}
              disabled={isBusy}
            >
              Cancel
            </button>
            <button
              type="button"
              className="utilization-uc-modal__btn utilization-uc-modal__btn--generate"
              onClick={onGenerate}
              disabled={isBusy}
            >
              {loading ? "Generating..." : "Generate"}
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UtilizationUcReportModal;
